export const environment = {
  production: false,
  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US', 'fr-FR'],
  serviceApiBaseUrl: 'https://staging-services.enrollandpay.com',
  serviceApiKey: '4fe3b6de-138e-4ba2-ae48-b178e86d8e76',
};
